import React from 'react';
import { Paper, Typography, useTheme } from '@mui/material';

interface BannerProps {
  icon?: any;
  severity?: 'success' | 'info' | 'error' | 'warning';
  title: string;
  subHeader?: string;
  elevation?: number;
}
export function Banner({
  title,
  subHeader,
  icon,
  elevation = 0,
  severity,
}: BannerProps) {
  const theme = useTheme();
  const bannerSeverity = () => {
    if (severity === 'success') {
      return theme.palette.success.main;
    }
    if (severity === 'error') {
      return theme.palette.error.main;
    }
    if (severity === 'warning') {
      return theme.palette.warning.main;
    }
    return '';
  };

  return (
    <Paper
      elevation={elevation}
      sx={{
        p: 2,
        mt: 2,
        mb: 2,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        columnGap: 1,
        background: bannerSeverity(),
      }}
    >
      {icon && icon}
      <Typography>{title}</Typography>
      <Typography>{subHeader && subHeader}</Typography>
    </Paper>
  );
}
